<template>
  <div class="forbidden-container">
    <div class="content-box">
      <div class="icon">🚧</div>
      <h1>项目暂停维护</h1>
      <p class="message">感谢您一直以来的支持与关注</p>
      <p class="sub-message">请使用App或小程序继续访问成就内容</p>
      <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-number">晋ICP备20001973号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenView',
  methods: {
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.forbidden-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #F5F5F5;
  padding: 20px;
}

.content-box {
  background: #fff;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 64px;
  margin-bottom: 20px;
}

h1 {
  color: #333;
  font-size: 28px;
  margin-bottom: 16px;
}

.message {
  color: #666;
  font-size: 18px;
  margin-bottom: 12px;
}

.sub-message {
  color: #999;
  font-size: 16px;
  margin-bottom: 30px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px;
  background: #818CE1;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.action-btn:hover {
  background: #6c78d9;
  transform: translateY(-2px);
}

.icp-number {
  color: #999;
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  transition: color 0.3s;
}

.icp-number:hover {
  color: #666;
}
</style>
